import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/photos')({
  component: PhotosLayout,
});

function PhotosLayout() {
  return <Outlet />;
}
